import styles from "@css/modules/pointsGuide.module.scss"
import Image from "next/image"
import step1Block1 from "@public/images/pointsGuide/step1Block1.webp"

export function StepHeader() {
    return (
        <div className={styles.stepHeader}>
            <div className={styles.left}>
                <h2>Tell us about your vacation habits</h2>
                <p>Answer a few simple questions and our proprietary point simulator will offer an optimized purchase plan</p>
            </div>
            <div className={styles.right}>
                <Image src={step1Block1} alt="step 1" width="261" height="270" />
            </div>
        </div>
    )
}
